/* Cosy Countdown theme — storefront behaviour */
(function () {
  'use strict';

  var T = window.theme || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return String(cents);
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var value;
    switch (match[1]) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function storage(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, value);
    } catch (e) { return null; }
  }

  var toastTimer;
  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2800);
  }

  function lockScroll(lock) { document.body.classList.toggle('no-scroll', !!lock); }

  /* ---------- Announcement bar ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var msgs = $$('.announcement__msg', bar);
    if (msgs.length < 2) return;
    var i = 0;
    var speed = (parseInt(bar.dataset.speed, 10) || 4) * 1000;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Mobile menu ---------- */
  var menu = $('#MenuDrawer');
  var menuOverlay = $('[data-menu-overlay]');
  function toggleMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menuOverlay && menuOverlay.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    lockScroll(open);
  }
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { toggleMenu(true); }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { toggleMenu(false); }); });
  menuOverlay && menuOverlay.addEventListener('click', function () { toggleMenu(false); });

  /* ---------- Modals ---------- */
  function openModal(id) {
    var m = document.getElementById(id);
    if (!m) return;
    m.classList.add('is-open');
    lockScroll(true);
    var close = $('[data-modal-close]', m);
    close && close.focus();
  }
  function closeModal(m) { m.classList.remove('is-open'); lockScroll(false); }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) { e.preventDefault(); openModal(opener.getAttribute('data-modal-open')); return; }
    var closer = e.target.closest('[data-modal-close]');
    if (closer) { closeModal(closer.closest('[data-modal]')); return; }
    if (e.target.matches('[data-modal]')) closeModal(e.target);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('[data-modal].is-open').forEach(closeModal);
    toggleMenu(false);
    Cart.close();
  });

  // Size guide unit toggle
  $$('[data-unit-toggle]').forEach(function (toggle) {
    var table = toggle.parentNode.querySelector('[data-size-table]');
    $$('button', toggle).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('button', toggle).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        var cm = btn.dataset.unit === 'cm';
        $$('[data-in]', table).forEach(function (td) {
          var v = parseFloat(td.dataset.in);
          td.textContent = cm ? (v * 2.54).toFixed(1) : v.toFixed(1);
        });
      });
    });
  });

  /* ---------- Countdown (resets daily at local midnight) ---------- */
  var countdowns = $$('[data-countdown]');
  if (countdowns.length) {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var now = new Date();
      var end = new Date(now); end.setHours(24, 0, 0, 0);
      var diff = Math.max(0, Math.floor((end - now) / 1000));
      var h = pad(Math.floor(diff / 3600)), m = pad(Math.floor((diff % 3600) / 60)), s = pad(diff % 60);
      countdowns.forEach(function (c) {
        $('[data-h]', c).textContent = h;
        $('[data-m]', c).textContent = m;
        $('[data-s]', c).textContent = s;
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Before / after slider ---------- */
  $$('[data-ba]').forEach(function (ba) {
    var range = $('[data-ba-range]', ba);
    var set = function (v) { ba.style.setProperty('--pos', v + '%'); };
    range.addEventListener('input', function () { set(range.value); });
    set(range.value);
    // Gentle hint animation the first time it scrolls into view
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.disconnect();
          var frames = [50, 30, 70, 50], k = 0;
          var step = function () {
            if (k >= frames.length) return;
            ba.style.transition = 'none';
            range.value = frames[k];
            set(frames[k]);
            k++;
            setTimeout(step, 450);
          };
          setTimeout(step, 300);
        });
      }, { threshold: 0.5 });
      io.observe(ba);
    }
  });

  /* ---------- UGC videos ---------- */
  $$('[data-ugc]').forEach(function (row) {
    var videos = $$('video', row);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); }
        });
      }, { threshold: 0.25 });
      videos.forEach(function (v) { v.removeAttribute('autoplay'); io.observe(v); });
    }
    $$('[data-ugc-sound]', row).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.parentNode.querySelector('video');
        if (!v) return;
        var unmute = v.muted;
        videos.forEach(function (o) { o.muted = true; });
        v.muted = !unmute;
        $$('[data-ugc-sound]', row).forEach(function (b) { b.innerHTML = SOUND_OFF; });
        btn.innerHTML = v.muted ? SOUND_OFF : SOUND_ON;
        if (!v.muted) v.play().catch(function () {});
      });
    });
  });
  var SOUND_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M23 9l-6 6M17 9l6 6"/></svg>';
  var SOUND_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a10 10 0 0 1 0 14"/></svg>';

  /* ---------- Collection sorting ---------- */
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Cart drawer ---------- */
  var Cart = (function () {
    var drawer = $('#CartDrawer');
    var overlay = $('[data-cart-overlay]');
    var useDrawer = T.cartType === 'drawer' && drawer;
    var prot = T.protection || {};
    var protId = prot.enabled && prot.variantId ? Number(prot.variantId) : null;
    var busy = false;

    function open() {
      if (!useDrawer) { window.location.href = T.routes.cartPage; return; }
      drawer.classList.add('is-open');
      overlay && overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      refresh().then(function () { drawer.focus(); });
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      overlay && overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (!$('[data-modal].is-open') && !(menu && menu.classList.contains('is-open'))) lockScroll(false);
    }

    function updateCount(cart) {
      var protQty = 0;
      cart.items.forEach(function (it) { if (protId && it.variant_id === protId) protQty += it.quantity; });
      var count = cart.item_count - protQty;
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count > 0 ? count : '';
        el.setAttribute('data-count', count);
      });
      var dc = $('[data-cart-drawer-count]');
      if (dc) dc.textContent = count > 0 ? '(' + count + ')' : '';
      return count;
    }

    function render(cart) {
      if (!drawer || !cart || !cart.items) return cart;
      var count = updateCount(cart);
      var body = $('[data-cart-body]', drawer);
      var foot = $('[data-cart-foot]', drawer);
      var protItem = null;

      if (count === 0) {
        body.innerHTML = '<div class="cart-drawer__empty"><p>' + escapeHtml(T.strings.cartEmpty) + '</p><a class="btn" href="/collections/all">Shop now</a></div>';
        foot.hidden = true;
      } else {
        foot.hidden = false;
        body.innerHTML = cart.items.map(function (item, idx) {
          if (protId && item.variant_id === protId) { protItem = item; return ''; }
          var line = idx + 1;
          var img = item.featured_image && item.featured_image.url
            ? '<img class="line__img" src="' + item.featured_image.url + (item.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="' + escapeHtml(item.product_title) + '" width="84" height="100" loading="lazy">'
            : '<div class="line__img"></div>';
          var variant = item.product_has_only_default_variant ? '' : '<div class="line__variant">' + escapeHtml(item.variant_title) + '</div>';
          var discounts = (item.line_level_discount_allocations || []).map(function (d) {
            return '<div class="line__discount">' + escapeHtml(d.discount_application.title) + ' (−' + formatMoney(d.amount) + ')</div>';
          }).join('');
          var compare = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
          return '<div class="line" data-line="' + line + '">' +
            '<a href="' + item.url + '">' + img + '</a>' +
            '<div><a class="line__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' + variant + discounts +
              '<div class="line__actions"><span class="qty">' +
                '<button type="button" data-line-change="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
                '<input type="number" value="' + item.quantity + '" min="0" data-line-input="' + line + '" aria-label="Quantity">' +
                '<button type="button" data-line-change="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
              '</span><button type="button" class="link line__remove" data-line-change="' + line + '" data-qty="0">' + escapeHtml(T.strings.remove) + '</button></div>' +
            '</div>' +
            '<div class="line__price">' + compare + formatMoney(item.final_line_price) + '</div>' +
          '</div>';
        }).join('');
      }

      // Totals
      var totalEl = $('[data-cart-total]', drawer);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      var savingsWrap = $('[data-cart-savings]', drawer);
      if (savingsWrap) {
        var save = cart.total_discount || 0;
        savingsWrap.hidden = !(save > 0);
        $('[data-cart-savings-amount]', drawer).textContent = '−' + formatMoney(save);
      }

      // Protection toggle
      var toggle = $('[data-protection-toggle]', drawer);
      if (toggle) toggle.checked = !!protItem;

      // Free shipping bar
      var fs = T.freeShipping || {};
      var shipWrap = $('[data-ship-wrap]', drawer);
      if (shipWrap && fs.enabled && fs.threshold > 0) {
        var rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
        var threshold = Math.round(fs.threshold * rate);
        var subtotal = cart.total_price - (protItem ? protItem.final_line_price : 0);
        var remaining = threshold - subtotal;
        var pct = Math.min(100, Math.max(0, (subtotal / threshold) * 100));
        $('[data-ship-text]', shipWrap).innerHTML = remaining > 0
          ? escapeHtml(fs.textBelow).replace('[amount]', '<strong>' + formatMoney(remaining) + '</strong>')
          : escapeHtml(fs.textReached);
        $('[data-ship-bar]', shipWrap).style.width = pct + '%';
        shipWrap.hidden = count === 0;
      }
      return cart;
    }

    function refresh() {
      return fetchJSON(T.routes.cart).then(function (cart) {
        return syncProtection(cart).then(render);
      }).catch(function () {});
    }

    // Keep protection consistent: remove it when the cart has nothing else, add it once by default if enabled.
    function syncProtection(cart) {
      if (!protId) return Promise.resolve(cart);
      var others = 0, protLine = null;
      cart.items.forEach(function (it, i) {
        if (it.variant_id === protId) protLine = { line: i + 1, qty: it.quantity };
        else others += it.quantity;
      });
      if (protLine && others === 0) return change(protLine.line, 0, true);
      if (protLine && protLine.qty > 1) return change(protLine.line, 1, true);
      if (!protLine && others > 0 && prot.defaultOn && storage('rc_protection_off') !== '1') {
        return fetchJSON(T.routes.cartAdd, { method: 'POST', body: JSON.stringify({ items: [{ id: protId, quantity: 1 }] }) })
          .then(function () { return fetchJSON(T.routes.cart); });
      }
      return Promise.resolve(cart);
    }

    function change(line, qty, raw) {
      drawer && drawer.classList.add('is-loading');
      return fetchJSON(T.routes.cartChange, { method: 'POST', body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (cart) { return raw ? cart : syncProtection(cart).then(render); })
        .catch(function (err) { toast((err && (err.description || err.message)) || 'Something went wrong'); })
        .then(function (cart) { drawer && drawer.classList.remove('is-loading'); return cart; });
    }

    function add(items) {
      if (busy) return Promise.reject();
      busy = true;
      return fetchJSON(T.routes.cartAdd, { method: 'POST', body: JSON.stringify({ items: items }) })
        .then(function () { busy = false; open(); })
        .catch(function (err) {
          busy = false;
          toast((err && (err.description || err.message)) || 'Could not add to cart');
          throw err;
        });
    }

    if (drawer) {
      drawer.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-line-change]');
        if (btn) change(Number(btn.dataset.lineChange), Math.max(0, Number(btn.dataset.qty)));
        if (e.target.closest('[data-cart-close]')) close();
      });
      drawer.addEventListener('change', function (e) {
        if (e.target.matches('[data-line-input]')) change(Number(e.target.dataset.lineInput), Math.max(0, parseInt(e.target.value, 10) || 0));
        if (e.target.matches('[data-protection-toggle]')) {
          var on = e.target.checked;
          storage('rc_protection_off', on ? '0' : '1');
          drawer.classList.add('is-loading');
          fetchJSON(T.routes.cart).then(function (cart) {
            var line = null;
            cart.items.forEach(function (it, i) { if (it.variant_id === protId) line = i + 1; });
            if (on && !line) {
              return fetchJSON(T.routes.cartAdd, { method: 'POST', body: JSON.stringify({ items: [{ id: protId, quantity: 1 }] }) }).then(refresh);
            }
            if (!on && line) return change(line, 0);
          }).then(function () { drawer.classList.remove('is-loading'); });
        }
      });
      overlay && overlay.addEventListener('click', close);
    }

    if (useDrawer) {
      $$('[data-cart-open]').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); open(); });
      });
    }

    return { open: open, close: close, add: add, refresh: refresh, useDrawer: useDrawer };
  })();

  /* ---------- Product ---------- */
  $$('[data-product]').forEach(function (root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var swatches = data.swatches || {};
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-id]', root);
    var atc = $('[data-atc]', root);
    var atcText = $('[data-atc-text]', root);
    var atcLabel = atcText ? atcText.textContent.trim() : T.strings.addToCart;
    var current = variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || variants[0];
    var sectionEl = root.closest('.shopify-section') || document;
    var sticky = $('[data-sticky-atc]', sectionEl);

    /* Gallery */
    var gallery = $('[data-gallery]', root);
    var slides = gallery ? $$('.gallery__slide', gallery) : [];
    var thumbs = $$('[data-thumb]', root);
    var dots = $$('.gallery__dots span', root);
    function goTo(i, smooth) {
      if (!gallery || !slides[i]) return;
      gallery.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function activeIndex() { return gallery ? Math.round(gallery.scrollLeft / (gallery.clientWidth || 1)) : 0; }
    if (gallery) {
      var raf;
      gallery.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = activeIndex();
          thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
          dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        });
      });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.dataset.thumb)); }); });
      var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
      prev && prev.addEventListener('click', function () { goTo(Math.max(0, activeIndex() - 1)); });
      next && next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, activeIndex() + 1)); });
    }
    function showMedia(mediaId) {
      if (!mediaId) return;
      var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (idx > -1) goTo(idx);
    }

    /* Variant selection */
    var fieldsets = $$('[data-option-index]', root);
    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === null || o === opts[i]; });
      });
    }
    function markAvailability() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var match = variants.find(function (v) {
            return v.options.every(function (o, i) { return o === test[i]; });
          });
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function updatePrice(v) {
      var wrap = $('[data-price-block]', root);
      if (!wrap || !v) return;
      $('[data-price]', wrap).textContent = formatMoney(v.price);
      var cmp = $('[data-compare]', wrap), save = $('[data-save]', wrap);
      var onSale = v.compare_at_price > v.price;
      if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? formatMoney(v.compare_at_price) : ''; }
      if (save) {
        save.hidden = !onSale;
        if (onSale) save.textContent = 'Save ' + Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + '%';
      }
    }

    function updateStock(v) {
      var el = $('[data-stock]', root);
      if (!el || !v) return;
      var threshold = Number(el.dataset.threshold) || 15;
      var text = $('[data-stock-text]', el);
      var bar = $('[data-stock-bar]', el);
      var low = v.inventory_tracked && v.inventory_quantity > 0 && v.inventory_quantity <= threshold;
      el.classList.toggle('stock--low', low || !v.available);
      if (!v.available) text.textContent = el.dataset.outText;
      else if (low) text.textContent = el.dataset.lowText.replace('[count]', v.inventory_quantity);
      else text.textContent = el.dataset.inText;
      if (bar) {
        bar.hidden = !low;
        if (low) bar.firstElementChild.style.width = Math.min(100, (v.inventory_quantity / threshold) * 100) + '%';
      }
    }

    function updateReveal() {
      var note = $('[data-reveal-note]', root);
      if (!note) return;
      var fs = note.closest('[data-option-index]');
      var checked = fs && $('input:checked', fs);
      if (!checked) return;
      var dot = $('[data-reveal-dot]', note);
      if (dot && swatches[checked.value]) dot.style.setProperty('--sw', swatches[checked.value]);
      var name = $('[data-reveal-name]', note);
      if (name) name.textContent = checked.value;
    }

    function updateButton(v) {
      if (!atc) return;
      var ok = v && v.available;
      atc.disabled = !ok;
      if (atcText) atcText.textContent = !v ? T.strings.unavailable : ok ? atcLabel : T.strings.soldOut;
      var sBtn = sticky && $('[data-sticky-btn]', sticky);
      if (sBtn) { sBtn.disabled = !ok; }
    }

    function onVariantChange() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        var label = $('[data-option-label]', fs);
        if (label) label.textContent = opts[i] || '';
      });
      var v = findVariant(opts);
      current = v;
      markAvailability();
      updateReveal();
      updateButton(v);
      if (!v) return;
      if (idInput) idInput.value = v.id;
      updatePrice(v);
      updateStock(v);
      showMedia(v.media_id);
      Bundles.syncFirst(v);
      Bundles.price();
      if (sticky) {
        var sv = $('[data-sticky-variant]', sticky), sp = $('[data-sticky-price]', sticky), si = $('[data-sticky-img]', sticky);
        if (sv) sv.textContent = v.title + ' · ';
        if (sp) sp.textContent = formatMoney(v.price);
        if (si && v.image) si.src = v.image;
      }
      if (root.dataset.updateUrl === 'true' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', onVariantChange); });
    if (fieldsets.length) markAvailability();

    /* Bundles */
    var Bundles = (function () {
      var wrap = $('[data-bundles]', root);
      if (!wrap) return { syncFirst: function () {}, price: function () {}, items: function () { return null; } };
      var tiers = $$('[data-bundle]', wrap);
      var formQty = $('[data-form-qty]', root);
      var touched = false;
      var byId = {};
      variants.forEach(function (v) { byId[v.id] = v; });

      function selected() { return tiers.find(function (t) { return t.classList.contains('is-selected'); }) || tiers[0]; }

      function tierVariantIds(tier) {
        var qty = Number(tier.dataset.qty) || 1;
        var selects = $$('[data-bundle-select]', tier);
        if (selects.length) return selects.map(function (s) { return Number(s.value); });
        var ids = [];
        for (var i = 0; i < qty; i++) ids.push(current ? current.id : variants[0].id);
        return ids;
      }

      function price() {
        tiers.forEach(function (tier) {
          var discount = Number(tier.dataset.discount) || 0;
          var ids = tierVariantIds(tier);
          var full = 0, compare = 0;
          ids.forEach(function (id) {
            var v = byId[id] || current || variants[0];
            if (!v) return;
            full += v.price;
            compare += v.compare_at_price > v.price ? v.compare_at_price : v.price;
          });
          var total = Math.round(full * (1 - discount / 100));
          var p = $('[data-bundle-price]', tier), c = $('[data-bundle-compare]', tier);
          if (p) p.textContent = formatMoney(total);
          if (c) c.textContent = compare > total ? formatMoney(compare) : '';
        });
        var sel = selected();
        if (formQty && sel) formQty.value = sel.dataset.qty;
      }

      function syncFirst(v) {
        // Changing the main picker updates every bundle item until the shopper edits items individually
        if (touched || !v) return;
        $$('[data-bundle-select]', wrap).forEach(function (s) { s.value = v.id; });
      }

      tiers.forEach(function (tier) {
        var radio = $('input[type="radio"]', tier);
        radio.addEventListener('change', function () {
          tiers.forEach(function (t) { t.classList.toggle('is-selected', t === tier); });
          price();
        });
      });
      wrap.addEventListener('change', function (e) {
        if (e.target.matches('[data-bundle-select]')) { touched = true; price(); }
      });
      // Stop clicks on selects from toggling the label radio
      $$('[data-bundle-select]', wrap).forEach(function (s) {
        s.addEventListener('click', function (e) { e.stopPropagation(); });
      });

      price();
      return {
        syncFirst: syncFirst,
        price: price,
        items: function () {
          var ids = tierVariantIds(selected());
          var grouped = {};
          ids.forEach(function (id) { grouped[id] = (grouped[id] || 0) + 1; });
          return Object.keys(grouped).map(function (id) { return { id: Number(id), quantity: grouped[id] }; });
        }
      };
    })();

    /* Quantity block */
    var qtyInput = $('[data-qty-input]', root);
    if (qtyInput) {
      $('[data-qty-minus]', root).addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
      $('[data-qty-plus]', root).addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
    }

    /* Add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!Cart.useDrawer) return; // native submit → cart page
        e.preventDefault();
        if (!current || !current.available) return;
        var items = Bundles.items() || [{ id: current.id, quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1 }];
        atc.disabled = true;
        if (atcText) atcText.textContent = T.strings.adding;
        Cart.add(items).catch(function () {}).then(function () { updateButton(current); });
      });
    }

    /* Sticky ATC */
    if (sticky && atc && 'IntersectionObserver' in window) {
      var sBtn = $('[data-sticky-btn]', sticky);
      var visible = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          if (show === visible) return;
          visible = show;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          sBtn.tabIndex = show ? 0 : -1;
        });
      });
      io.observe(atc);
      sBtn.addEventListener('click', function () {
        if (form && form.requestSubmit) form.requestSubmit(atc);
        else atc.click();
      });
    }
  });

  /* Initial cart count sync (handles back/forward cache) */
  window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.refresh(); });
})();

/* Delivery timeline: fills in date ranges from today */
(function () {
  function fmt(d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); }
  function add(n) { var d = new Date(); d.setDate(d.getDate() + n); return d; }
  function range(a, b) { return a === b ? fmt(add(a)) : fmt(add(a)) + ' – ' + fmt(add(b)); }
  function init() {
    document.querySelectorAll('[data-timeline]').forEach(function (el) {
      var ds = el.dataset;
      var ship = el.querySelector('[data-tl="ship"]'), arrive = el.querySelector('[data-tl="arrive"]');
      if (ship) ship.textContent = range(+ds.shipMin, +ds.shipMax);
      if (arrive) arrive.textContent = range(+ds.arriveMin, +ds.arriveMax);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
